import { IonItemDivider, IonLabel } from "@ionic/react";
import { useSelector } from "react-redux";

import { Template } from "../../../@types/template";
import { selectTemplateList } from "../../../store/templateList/selectors/selectTemplateList";
import { TemplateListItem } from "./TemplateListItem";

export const TemplateListContainer = () => {
  const templateList = useSelector(selectTemplateList);
  return (
    <>
      <IonItemDivider class="ion-margin-bottom">
        <IonLabel>
          <p>{templateList.length} resultados</p>
        </IonLabel>
      </IonItemDivider>
      {templateList.map((template: Template) => (
        <TemplateListItem key={template.id} template={template} />
      ))}
    </>
  );
};
